import {
  Box,
  ButtonBase,
  IconButton,
  Popover,
  Typography,
  useTheme
} from "@mui/material";
import React from "react";
import { FormattedMessage } from "react-intl";
import CaretLeft from "../../../../public/assets/icons/CaretLeft";
import { TTheme } from "../../../utils/configs/setupTheme";

function TimeSelect(props: any) {
  const theme: TTheme = useTheme();
  const { value, onChange } = props;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const options = [
    {
      id: "week",
      name: "common.week"
    },
    {
      id: "month",
      name: "common.month"
    },
    {
      id: "year",
      name: "common.year"
    }
  ];

  const handleClick = (event?: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box>
      <Box display="flex" flexDirection="row" alignItems="center">
        <Typography variant="body1" className="font-semibold">
          {options.find((v) => v.id === value)?.name && (
            <FormattedMessage id={options.find((v) => v.id === value)?.name} />
          )}
        </Typography>
        <div role="presentation" onClick={handleClick}>
          <IconButton>
            <CaretLeft />
          </IconButton>
        </div>
      </Box>
      <Popover
        open={!!anchorEl}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left"
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center"
        }}
      >
        <Box display="flex" flexDirection="column">
          {options.map((v, index) => (
            <ButtonBase
              style={{
                padding: 10,
                backgroundColor:
                  v.id === value ? theme.palette.primary.gray : undefined
              }}
              key={index}
              onClick={() => {
                onChange(v.id);
                handleClose();
              }}
              className="text-black"
            >
              <Typography variant="body2">
                <FormattedMessage id={v.name} />
              </Typography>
            </ButtonBase>
          ))}
        </Box>
      </Popover>
    </Box>
  );
}

export default TimeSelect;
